export { default as component } from "../../../../src/routes/[prefix]/(feature)/activity-problem/+page.svelte";